import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {Popover} from 'antd';
import {WeaIntro} from 'ecCom';
const {Step, Intro} = WeaIntro;

import E9TopMenuContent from '../E9TopMenuContent';

@inject('portalIntroStore')
@inject('portalThemeStore')
@observer
class IntroStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
    }

    componentDidMount() {
    }

    render() {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {topMenuObj, topMenuVisible} = portalThemeStore;
        const {topMenu = [], topMenuSelected = {}} = topMenuObj;
        const _topMenu = toJS(topMenu);
        const _topMenuSelected = toJS(topMenuSelected);
        const {name:selectedName} = _topMenuSelected;
        const {intro_step} = portalIntroStore;

        return (
            <Popover
                trigger="hover"
                placement="bottomLeft"
                content={<Step id={'portal-intro1'}><E9TopMenuContent topMenu={_topMenu} topMenuSelected={_topMenuSelected} onVisibleChange={ this.onVisibleChange}/></Step>}
                overlayClassName="e9header-top-menu-overlay"
                visible={topMenuVisible}
                onVisibleChange={this.onVisibleChange}
                afterPopupVisibleChange={v => intro_step.intro1 && v && setTimeout(() => window.portal_intro.start(), 500)}
            >
                <div>
                    <div className="e9header-top-menu-icon">
                        <i className="wevicon-top-menu-common"/>
                    </div>
                    <div className="e9header-top-menu-name wea-f14" title={selectedName}>{selectedName}</div>
                    <Intro ref={el => this.intro = el} onReady={(intro) => {
                        window.portal_intro = intro;
                        portalIntroStore.getPortalIntroInfo(portalThemeStore);
                    }}/>
                </div>
            </Popover>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {intro_step} = portalIntroStore;
        !intro_step.intro1 && portalThemeStore.onTopMenuVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
            portalThemeStore.onFreqUseMenuVisibleChange(false);
            portalThemeStore.onQuickSearchTypesVisibleChange(false);
            portalThemeStore.onQuickSearchRcmdVisibleChange(false);
            portalThemeStore.onToolbarMoreMenuVisibleChange(false);
            portalThemeStore.onAccountVisibleChange(false);
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }
}

export default IntroStep1;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/portalintro/IntroStep1.js